module.exports = __webpack_public_path__ + "img/maintop.bf45eb0.png";